import Vue from 'vue'
import VueRouter from 'vue-router'
import { authGuard, guestGuard } from './guards'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL || '/gestioncomercial/',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/Dashboard.vue'),
      meta: {
        pageTitle: 'Escritorio',
        breadcrumb: [
          {
            text: 'Escritorio',
            active: true,
          },
        ],
      },
    },
    // Proyectos
    {
      path: '/proyectos',
      name: 'proyectos-lista',
      component: () => import('@/views/ProyectosLista.vue'),
      meta: {
        pageTitle: 'Lista de Proyectos',
        breadcrumb: [
          {
            text: 'Proyectos',
            active: false,
          },
          {
            text: 'Lista',
            active: true,
          },
        ],
      },
    },
    {
      path: '/proyectos/nuevo',
      name: 'proyectos-nuevo',
      component: () => import('@/views/ProyectosNuevo.vue'),
      meta: {
        pageTitle: 'Nuevo Proyecto',
        breadcrumb: [
          {
            text: 'Proyectos',
            active: false,
          },
          {
            text: 'Nuevo',
            active: true,
          },
        ],
      },
    },
    {
      path: '/proyectos/:id',
      name: 'proyectos-detalle',
      component: () => import('@/views/ProyectosDetalle.vue'),
      meta: {
        pageTitle: 'Detalle del Proyecto',
        breadcrumb: [
          {
            text: 'Proyectos',
            active: false,
          },
          {
            text: 'Detalle',
            active: true,
          },
        ],
      },
    },
    {
      path: '/proyectos/:id/editar',
      name: 'proyectos-editar',
      component: () => import('@/views/ProyectosEditar.vue'),
      meta: {
        pageTitle: 'Editar Proyecto',
        breadcrumb: [
          {
            text: 'Proyectos',
            active: false,
          },
          {
            text: 'Editar',
            active: true,
          },
        ],
      },
    },
    // Actividades
    {
      path: '/actividades',
      name: 'actividades-lista',
      component: () => import('@/views/ActividadesLista.vue'),
      meta: {
        pageTitle: 'Lista de Actividades',
        breadcrumb: [
          {
            text: 'Actividades',
            active: false,
          },
          {
            text: 'Lista',
            active: true,
          },
        ],
      },
    },
    {
      path: '/actividades/calendario',
      name: 'actividades-calendario',
      component: () => import('@/views/CalendarioActividades.vue'),
      meta: {
        pageTitle: 'Calendario de Actividades',
        breadcrumb: [
          {
            text: 'Actividades',
            active: false,
          },
          {
            text: 'Calendario',
            active: true,
          },
        ],
      },
    },
    {
      path: '/actividades/nueva',
      name: 'actividades-nueva',
      component: () => import('@/views/ActividadesNueva.vue'),
      meta: {
        pageTitle: 'Nueva Actividad',
        breadcrumb: [
          {
            text: 'Actividades',
            active: false,
          },
          {
            text: 'Nueva',
            active: true,
          },
        ],
      },
    },
    {
      path: '/actividades/:id',
      name: 'actividades-detalle',
      component: () => import('@/views/ActividadesDetalle.vue'),
      meta: {
        pageTitle: 'Detalle de Actividad',
        breadcrumb: [
          {
            text: 'Actividades',
            active: false,
          },
          {
            text: 'Detalle',
            active: true,
          },
        ],
      },
    },
    {
      path: '/actividades/:id/editar',
      name: 'actividades-editar',
      component: () => import('@/views/ActividadesEditar.vue'),
      meta: {
        pageTitle: 'Editar Actividad',
        breadcrumb: [
          {
            text: 'Actividades',
            active: false,
          },
          {
            text: 'Editar',
            active: true,
          },
        ],
      },
    },
    // Obras
    {
      path: '/obras',
      name: 'obras-lista',
      component: () => import('@/views/ObrasLista.vue'),
      meta: {
        pageTitle: 'Lista de Obras',
        breadcrumb: [
          {
            text: 'Obras',
            active: false,
          },
          {
            text: 'Lista',
            active: true,
          },
        ],
      },
    },
    {
      path: '/obras/nueva',
      name: 'obras-nueva',
      component: () => import('@/views/ObrasNueva.vue'),
      meta: {
        pageTitle: 'Nueva Obra',
        breadcrumb: [
          {
            text: 'Obras',
            active: false,
          },
          {
            text: 'Nueva',
            active: true,
          },
        ],
      },
    },
    {
      path: '/obras/:id',
      name: 'obras-detalle',
      component: () => import('@/views/ObraDetalle.vue'),
      meta: {
        pageTitle: 'Detalle de Obra',
        breadcrumb: [
          {
            text: 'Obras',
            active: false,
          },
          {
            text: 'Detalle',
            active: true,
          },
        ],
      },
    },
    {
      path: '/obras/:id/editar',
      name: 'obras-editar',
      component: () => import('@/views/ObraEditar.vue'),
      meta: {
        pageTitle: 'Editar Obra',
        breadcrumb: [
          {
            text: 'Obras',
            active: false,
          },
          {
            text: 'Editar',
            active: true,
          },
        ],
      },
    },
    // Empresas
    {
      path: '/empresas',
      name: 'empresas-lista',
      component: () => import('@/views/EmpresasLista.vue'),
      meta: {
        pageTitle: 'Lista de Empresas',
        breadcrumb: [
          {
            text: 'Empresas',
            active: false,
          },
          {
            text: 'Lista',
            active: true,
          },
        ],
      },
    },
    {
      path: '/empresas/nueva',
      name: 'empresas-nueva',
      component: () => import('@/views/EmpresasNueva.vue'),
      meta: {
        pageTitle: 'Nueva Empresa',
        breadcrumb: [
          {
            text: 'Empresas',
            active: false,
          },
          {
            text: 'Nueva',
            active: true,
          },
        ],
      },
    },
    {
      path: '/empresas/:id',
      name: 'empresas-detalle',
      component: () => import('@/views/EmpresaDetalle.vue'),
      meta: {
        pageTitle: 'Detalle de Empresa',
        breadcrumb: [
          {
            text: 'Empresas',
            active: false,
          },
          {
            text: 'Detalle',
            active: true,
          },
        ],
      },
    },
    {
      path: '/empresas/:id/editar',
      name: 'empresas-editar',
      component: () => import('@/views/EmpresaEditar.vue'),
      meta: {
        pageTitle: 'Editar Empresa',
        breadcrumb: [
          {
            text: 'Empresas',
            active: false,
          },
          {
            text: 'Editar',
            active: true,
          },
        ],
      },
    },
    // Contactos
    {
      path: '/contactos',
      name: 'contactos-lista',
      component: () => import('@/views/ContactosListaOptions.vue'),
      meta: {
        pageTitle: 'Lista de Contactos',
        breadcrumb: [
          {
            text: 'Contactos',
            active: false,
          },
          {
            text: 'Lista',
            active: true,
          },
        ],
      },
    },
    {
      path: '/contactos/nuevo',
      name: 'contactos-nuevo',
      component: () => import('@/views/ContactosNuevo.vue'),
      meta: {
        pageTitle: 'Nuevo Contacto',
        breadcrumb: [
          {
            text: 'Contactos',
            active: false,
          },
          {
            text: 'Nuevo',
            active: true,
          },
        ],
      },
    },
    {
      path: '/contactos/:id',
      name: 'contactos-detalle',
      component: () => import('@/views/ContactosDetalle.vue'),
      meta: {
        pageTitle: 'Detalle del Contacto',
        breadcrumb: [
          {
            text: 'Contactos',
            active: false,
          },
          {
            text: 'Detalle',
            active: true,
          },
        ],
      },
    },
    {
      path: '/contactos/:id/editar',
      name: 'contactos-editar',
      component: () => import('@/views/ContactosEditar.vue'),
      meta: {
        pageTitle: 'Editar Contacto',
        breadcrumb: [
          {
            text: 'Contactos',
            active: false,
          },
          {
            text: 'Editar',
            active: true,
          },
        ],
      },
    },
    // Plantillas de Correo
    {
      path: '/plantillas',
      name: 'plantillas-lista',
      component: () => import('@/views/PlantillasCorreo.vue'),
      meta: {
        pageTitle: 'Plantillas de Correo',
        breadcrumb: [
          {
            text: 'Plantillas de Correo',
            active: true,
          },
        ],
      },
    },
    // Usuarios
    {
      path: '/usuarios',
      name: 'usuarios-lista',
      component: () => import('@/views/UsuariosLista.vue'),
      meta: {
        pageTitle: 'Lista de Usuarios',
        breadcrumb: [
          {
            text: 'Usuarios',
            active: false,
          },
          {
            text: 'Lista',
            active: true,
          },
        ],
      },
    },
    {
      path: '/usuarios/nuevo',
      name: 'usuarios-nuevo',
      component: () => import('@/views/UsuariosNuevo.vue'),
      meta: {
        pageTitle: 'Nuevo Usuario',
        breadcrumb: [
          {
            text: 'Usuarios',
            active: false,
          },
          {
            text: 'Nuevo',
            active: true,
          },
        ],
      },
    },
    {
      path: '/usuarios/roles',
      name: 'usuarios-roles',
      component: () => import('@/views/UsuariosRoles.vue'),
      meta: {
        pageTitle: 'Roles y Permisos',
        breadcrumb: [
          {
            text: 'Usuarios',
            active: false,
          },
          {
            text: 'Roles',
            active: true,
          },
        ],
      },
    },
    {
      path: '/usuarios/:id',
      name: 'usuarios-detalle',
      component: () => import('@/views/UsuariosDetalle.vue'),
      meta: {
        pageTitle: 'Detalle de Usuario',
        breadcrumb: [
          {
            text: 'Usuarios',
            active: false,
          },
          {
            text: 'Detalle',
            active: true,
          },
        ],
      },
    },
    {
      path: '/usuarios/:id/editar',
      name: 'usuarios-editar',
      component: () => import('@/views/UsuariosEditar.vue'),
      meta: {
        pageTitle: 'Editar Usuario',
        breadcrumb: [
          {
            text: 'Usuarios',
            active: false,
          },
          {
            text: 'Editar',
            active: true,
          },
        ],
      },
    },
    // Reportes
    {
      path: '/reportes/proyectos',
      name: 'reportes-proyectos',
      component: () => import('@/views/ReportesProyectos.vue'),
      meta: {
        pageTitle: 'Reportes de Proyectos',
        breadcrumb: [
          {
            text: 'Reportes',
            active: false,
          },
          {
            text: 'Proyectos',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportes/actividades',
      name: 'reportes-actividades',
      component: () => import('@/views/ReportesActividades.vue'),
      meta: {
        pageTitle: 'Reportes de Actividades',
        breadcrumb: [
          {
            text: 'Reportes',
            active: false,
          },
          {
            text: 'Actividades',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportes/obras',
      name: 'reportes-obras',
      component: () => import('@/views/ReportesObras.vue'),
      meta: {
        pageTitle: 'Reportes de Obras',
        breadcrumb: [
          {
            text: 'Reportes',
            active: false,
          },
          {
            text: 'Obras',
            active: true,
          },
        ],
      },
    },
    // Catálogo
    {
      path: '/catalogo',
      name: 'catalogo',
      component: () => import('@/views/CatalogoTiposObras.vue'),
      meta: {
        pageTitle: 'Catálogo',
        breadcrumb: [
          {
            text: 'Catálogo',
            active: true,
          },
        ],
      },
    },
    {
      path: '/catalogo/estados-actividades',
      name: 'catalogo-estados-actividades',
      component: () => import('@/views/CatalogoEstadosActividades.vue'),
      meta: {
        pageTitle: 'Estados de Actividades',
        breadcrumb: [
          {
            text: 'Catálogo',
            active: false,
          },
          {
            text: 'Estados de Actividades',
            active: true,
          },
        ],
      },
    },
    {
      path: '/catalogo/acciones-actividades',
      name: 'catalogo-acciones-actividades',
      component: () => import('@/views/CatalogoAccionesActividades.vue'),
      meta: {
        pageTitle: 'Acciones de Actividades',
        breadcrumb: [
          {
            text: 'Catálogo',
            active: false,
          },
          {
            text: 'Acciones de Actividades',
            active: true,
          },
        ],
      },
    },
    {
      path: '/catalogo/tipos-obras',
      name: 'catalogo-tipos-obras',
      component: () => import('@/views/CatalogoTiposObras.vue'),
      meta: {
        pageTitle: 'Tipos de Obras',
        breadcrumb: [
          {
            text: 'Catálogo',
            active: false,
          },
          {
            text: 'Tipos de Obras',
            active: true,
          },
        ],
      },
    },
    {
      path: '/catalogo/referencias-obras',
      name: 'catalogo-referencias-obras',
      component: () => import('@/views/CatalogoReferenciasObras.vue'),
      meta: {
        pageTitle: 'Referencias de Obras',
        breadcrumb: [
          {
            text: 'Catálogo',
            active: false,
          },
          {
            text: 'Referencias de Obras',
            active: true,
          },
        ],
      },
    },
    {
      path: '/catalogo/fases',
      name: 'catalogo-fases',
      component: () => import('@/views/CatalogoFases.vue'),
      meta: {
        pageTitle: 'Fases',
        breadcrumb: [
          {
            text: 'Catálogo',
            active: false,
          },
          {
            text: 'Fases',
            active: true,
          },
        ],
      },
    },
    {
      path: '/catalogo/estados-proyectos',
      name: 'catalogo-estados-proyectos',
      component: () => import('@/views/CatalogoEstadosObras.vue'),
      meta: {
        pageTitle: 'Estados de Proyectos',
        breadcrumb: [
          {
            text: 'Catálogo',
            active: false,
          },
          {
            text: 'Estados de Proyectos',
            active: true,
          },
        ],
      },
    },
    {
      path: '/catalogo/categorias-archivos',
      name: 'catalogo-categorias-archivos',
      component: () => import('@/views/CatalogoCategoriasArchivos.vue'),
      meta: {
        pageTitle: 'Categorías de Archivos',
        breadcrumb: [
          {
            text: 'Catálogo',
            active: false,
          },
          {
            text: 'Categorías de Archivos',
            active: true,
          },
        ],
      },
    },
    {
      path: '/catalogo/tipos-empresas',
      name: 'catalogo-tipos-empresas',
      component: () => import('@/views/CatalogoTiposEmpresas.vue'),
      meta: {
        pageTitle: 'Tipos de Empresas',
        breadcrumb: [
          {
            text: 'Catálogo',
            active: false,
          },
          {
            text: 'Tipos de Empresas',
            active: true,
          },
        ],
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/Profile.vue'),
      meta: {
        pageTitle: 'Mi Perfil',
        breadcrumb: [
          {
            text: 'Configuración',
            active: false,
          },
          {
            text: 'Mi Perfil',
            active: true,
          },
        ],
      },
    },
    // Rutas de autenticación
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        requiresAuth: false,
      },
      beforeEnter: guestGuard,
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('@/views/ResetPassword.vue'),
      meta: {
        layout: 'full',
        requiresAuth: false,
      },
    },
    {
      path: '/login-simple',
      name: 'login-simple',
      component: () => import('@/views/LoginSimple.vue'),
      meta: {
        layout: 'full',
        requiresAuth: false,
      },
      beforeEnter: guestGuard,
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// Guard global para verificar autenticación
router.beforeEach(authGuard)

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
